import { Observable } from 'rxjs';
import { AsyncJobResponse } from '../interfaces/async-job-response.interface';

export abstract class AsyncJobsFetcherService {
    public abstract getJobResult<T>(job: string): Observable<AsyncJobResponse<T>>;
}
